export let ExpressOrderItemType = /*#__PURE__*/function (ExpressOrderItemType) {
  ExpressOrderItemType["Product"] = "product";
  ExpressOrderItemType["Fee"] = "fee";
  return ExpressOrderItemType;
}({});
export let ExpressCheckoutButtonsState = /*#__PURE__*/function (ExpressCheckoutButtonsState) {
  ExpressCheckoutButtonsState["LOADING"] = "LOADING";
  ExpressCheckoutButtonsState["LOADED_WITHOUT_BUTTONS"] = "LOADED_WITHOUT_BUTTONS";
  ExpressCheckoutButtonsState["LOADED_WITH_BUTTONS"] = "LOADED_WITH_BUTTONS";
  return ExpressCheckoutButtonsState;
}({});
//# sourceMappingURL=types.js.map